var Le = Object.defineProperty, Ue = Object.defineProperties;
var Ve = Object.getOwnPropertyDescriptors;
var z = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty, Q = Object.prototype.propertyIsEnumerable;
var G = (e, t, o) => t in e ? Le(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, l = (e, t) => {
  for (var o in t || (t = {}))
    J.call(t, o) && G(e, o, t[o]);
  if (z)
    for (var o of z(t))
      Q.call(t, o) && G(e, o, t[o]);
  return e;
}, w = (e, t) => Ue(e, Ve(t));
var D = (e, t) => {
  var o = {};
  for (var n in e)
    J.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && z)
    for (var n of z(e))
      t.indexOf(n) < 0 && Q.call(e, n) && (o[n] = e[n]);
  return o;
};
import { jsx as v, jsxs as ae } from "react/jsx-runtime";
import { useRef as _, useEffect as Xe, cloneElement as Ye, useState as W, useCallback as I } from "react";
import { u as se, O as ie, i as Be, g as He } from "./OptionalPortal-Ctng3n6E.js";
import { a as Ze, b as qe } from "./get-size-rXzn3RsE.js";
import { f as le, e as A, B as Ge, c as Je, g as Qe, h as We } from "./factory--gUH4vxz.js";
import { u as eo } from "./use-resolved-styles-api-Dzbxdfp5.js";
import { u as oo } from "./DirectionProvider-CT8S13Cp.js";
import { F as to, g as ro, u as no, a as ao, o as so, s as io, l as ee, f as oe, i as te, b as lo, c as co, d as fo } from "./use-floating-auto-update-BsR9fBir.js";
import { u as uo, F as po, O as go } from "./FocusTrap-BdFOM_S4.js";
import { T as de, u as re } from "./Transition-DN_8_tJg.js";
import { c as wo } from "./create-safe-context-DqDyoPVE.js";
import { r as mo } from "./rem-CMQJ_ZTp.js";
import { u as ho } from "./use-uncontrolled-J2aphITS.js";
import { u as yo } from "./use-id-DjDiWRdO.js";
const vo = () => {
};
function xo(e, t = { active: !0 }) {
  return typeof e != "function" || !t.active ? t.onKeyDown || vo : (o) => {
    var n;
    o.key === "Escape" && (e(o), (n = t.onTrigger) == null || n.call(t));
  };
}
const ne = ["mousedown", "touchstart"];
function Po(e, t, o) {
  const n = _(null);
  return Xe(() => {
    const c = (d) => {
      const { target: i } = d != null ? d : {};
      if (Array.isArray(o)) {
        const s = (i == null ? void 0 : i.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(i) && i.tagName !== "HTML";
        o.every((f) => !!f && !d.composedPath().includes(f)) && !s && e();
      } else n.current && !n.current.contains(i) && e();
    };
    return (t || ne).forEach((d) => document.addEventListener(d, c)), () => {
      (t || ne).forEach((d) => document.removeEventListener(d, c));
    };
  }, [n, e, o]), n;
}
const [Oo, ce] = wo(
  "Popover component was not found in the tree"
);
var fe = { dropdown: "m_38a85659", arrow: "m_a31dc6c1", overlay: "m_3d7bc908" };
const Do = {}, M = le((e, t) => {
  var T, O, x, P, S;
  const o = A("PopoverDropdown", Do, e), C = o, {
    className: n,
    style: c,
    vars: d,
    children: i,
    onKeyDownCapture: s,
    variant: a,
    classNames: f,
    styles: p
  } = C, m = D(C, [
    "className",
    "style",
    "vars",
    "children",
    "onKeyDownCapture",
    "variant",
    "classNames",
    "styles"
  ]), r = ce(), h = uo({
    opened: r.opened,
    shouldReturnFocus: r.returnFocus
  }), R = r.withRoles ? {
    "aria-labelledby": r.getTargetId(),
    id: r.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {}, b = se(t, r.floating);
  return r.disabled ? null : /* @__PURE__ */ v(ie, w(l({}, r.portalProps), { withinPortal: r.withinPortal, children: /* @__PURE__ */ v(
    de,
    w(l({
      mounted: r.opened
    }, r.transitionProps), {
      transition: ((T = r.transitionProps) == null ? void 0 : T.transition) || "fade",
      duration: (x = (O = r.transitionProps) == null ? void 0 : O.duration) != null ? x : 150,
      keepMounted: r.keepMounted,
      exitDuration: typeof ((P = r.transitionProps) == null ? void 0 : P.exitDuration) == "number" ? r.transitionProps.exitDuration : (S = r.transitionProps) == null ? void 0 : S.duration,
      children: (E) => {
        var F, N;
        return /* @__PURE__ */ v(po, { active: r.trapFocus && r.opened, innerRef: b, children: /* @__PURE__ */ ae(
          Ge,
          w(l(w(l(l({}, R), m), {
            variant: a,
            onKeyDownCapture: xo(r.onClose, {
              active: r.closeOnEscape,
              onTrigger: h,
              onKeyDown: s
            }),
            "data-position": r.placement,
            "data-fixed": r.floatingStrategy === "fixed" || void 0
          }), r.getStyles("dropdown", {
            className: n,
            props: o,
            classNames: f,
            styles: p,
            style: [
              w(l({}, E), {
                zIndex: r.zIndex,
                top: (F = r.y) != null ? F : 0,
                left: (N = r.x) != null ? N : 0,
                width: r.width === "target" ? void 0 : mo(r.width)
              }),
              r.resolvedStyles.dropdown,
              p == null ? void 0 : p.dropdown,
              c
            ]
          })), {
            children: [
              i,
              /* @__PURE__ */ v(
                to,
                l({
                  ref: r.arrowRef,
                  arrowX: r.arrowX,
                  arrowY: r.arrowY,
                  visible: r.withArrow,
                  position: r.placement,
                  arrowSize: r.arrowSize,
                  arrowRadius: r.arrowRadius,
                  arrowOffset: r.arrowOffset,
                  arrowPosition: r.arrowPosition
                }, r.getStyles("arrow", {
                  props: o,
                  classNames: f,
                  styles: p
                }))
              )
            ]
          })
        ) });
      }
    })
  ) }));
});
M.classes = fe;
M.displayName = "@mantine/core/PopoverDropdown";
const Ro = {
  refProp: "ref",
  popupType: "dialog"
}, ue = le((e, t) => {
  const p = A(
    "PopoverTarget",
    Ro,
    e
  ), { children: o, refProp: n, popupType: c } = p, d = D(p, ["children", "refProp", "popupType"]);
  if (!Be(o))
    throw new Error(
      "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const i = d, s = ce(), a = se(s.reference, ro(o), t), f = s.withRoles ? {
    "aria-haspopup": c,
    "aria-expanded": s.opened,
    "aria-controls": s.getDropdownId(),
    id: s.getTargetId()
  } : {};
  return Ye(o, l(w(l(l(l({}, i), f), s.targetProps), {
    className: Je(
      s.targetProps.className,
      i.className,
      o.props.className
    ),
    [n]: a
  }), s.controlled ? null : { onClick: s.onToggle }));
});
ue.displayName = "@mantine/core/PopoverTarget";
function bo(e) {
  if (e === void 0)
    return { shift: !0, flip: !0 };
  const t = l({}, e);
  return e.shift === void 0 && (t.shift = !0), e.flip === void 0 && (t.flip = !0), t;
}
function Co(e, t) {
  const o = bo(e.middlewares), n = [so(e.offset)];
  return o.shift && n.push(
    io(
      typeof o.shift == "boolean" ? { limiter: ee(), padding: 5 } : l({ limiter: ee(), padding: 5 }, o.shift)
    )
  ), o.flip && n.push(
    typeof o.flip == "boolean" ? oe() : oe(o.flip)
  ), o.inline && n.push(
    typeof o.inline == "boolean" ? te() : te(o.inline)
  ), n.push(lo({ element: e.arrowRef, padding: e.arrowOffset })), (o.size || e.width === "target") && n.push(
    co(w(l({}, typeof o.size == "boolean" ? {} : o.size), {
      apply(a) {
        var f = a, { rects: c, availableWidth: d, availableHeight: i } = f, s = D(f, ["rects", "availableWidth", "availableHeight"]);
        var r, h;
        const m = (h = (r = t().refs.floating.current) == null ? void 0 : r.style) != null ? h : {};
        o.size && (typeof o.size == "object" && o.size.apply ? o.size.apply(l({ rects: c, availableWidth: d, availableHeight: i }, s)) : Object.assign(m, {
          maxWidth: `${d}px`,
          maxHeight: `${i}px`
        })), e.width === "target" && Object.assign(m, {
          width: `${c.reference.width}px`
        });
      }
    }))
  ), n;
}
function To(e) {
  const [t, o] = ho({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), n = _(t), c = () => {
    t && o(!1);
  }, d = () => o(!t), i = no({
    strategy: e.strategy,
    placement: e.position,
    middleware: Co(e, () => i)
  });
  return ao({
    opened: t,
    position: e.position,
    positionDependencies: e.positionDependencies || [],
    floating: i
  }), re(() => {
    var s;
    (s = e.onPositionChange) == null || s.call(e, i.placement);
  }, [i.placement]), re(() => {
    var s, a;
    t !== n.current && (t ? (a = e.onOpen) == null || a.call(e) : (s = e.onClose) == null || s.call(e)), n.current = t;
  }, [t, e.onClose, e.onOpen]), {
    floating: i,
    controlled: typeof e.opened == "boolean",
    opened: t,
    onClose: c,
    onToggle: d
  };
}
const So = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transitionProps: { transition: "fade", duration: 150 },
  middlewares: { flip: !0, shift: !0, inline: !1 },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: !0,
  withinPortal: !0,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  withOverlay: !1,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: He("popover"),
  __staticSelector: "Popover",
  width: "max-content"
}, Eo = We((e, { radius: t, shadow: o }) => ({
  dropdown: {
    "--popover-radius": t === void 0 ? void 0 : qe(t),
    "--popover-shadow": Ze(o)
  }
}));
function k(e) {
  var X, Y, B, H, Z, q;
  const t = A("Popover", So, e), V = t, {
    children: o,
    position: n,
    offset: c,
    onPositionChange: d,
    positionDependencies: i,
    opened: s,
    transitionProps: a,
    onExitTransitionEnd: f,
    onEnterTransitionEnd: p,
    width: m,
    middlewares: r,
    withArrow: h,
    arrowSize: R,
    arrowOffset: b,
    arrowRadius: C,
    arrowPosition: T,
    unstyled: O,
    classNames: x,
    styles: P,
    closeOnClickOutside: S,
    withinPortal: E,
    portalProps: F,
    closeOnEscape: N,
    clickOutsideEvents: pe,
    trapFocus: ge,
    onClose: we,
    onOpen: me,
    onChange: he,
    zIndex: ye,
    radius: ve,
    shadow: xe,
    id: Pe,
    defaultOpened: Oe,
    __staticSelector: $,
    withRoles: De,
    disabled: Re,
    returnFocus: be,
    variant: Ce,
    keepMounted: Te,
    vars: Se,
    floatingStrategy: j,
    withOverlay: Ee,
    overlayProps: y
  } = V, Fe = D(V, [
    "children",
    "position",
    "offset",
    "onPositionChange",
    "positionDependencies",
    "opened",
    "transitionProps",
    "onExitTransitionEnd",
    "onEnterTransitionEnd",
    "width",
    "middlewares",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "unstyled",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "withinPortal",
    "portalProps",
    "closeOnEscape",
    "clickOutsideEvents",
    "trapFocus",
    "onClose",
    "onOpen",
    "onChange",
    "zIndex",
    "radius",
    "shadow",
    "id",
    "defaultOpened",
    "__staticSelector",
    "withRoles",
    "disabled",
    "returnFocus",
    "variant",
    "keepMounted",
    "vars",
    "floatingStrategy",
    "withOverlay",
    "overlayProps"
  ]), K = Qe({
    name: $,
    props: t,
    classes: fe,
    classNames: x,
    styles: P,
    unstyled: O,
    rootSelector: "dropdown",
    vars: Se,
    varsResolver: Eo
  }), { resolvedStyles: Ne } = eo({ classNames: x, styles: P, props: t }), L = _(null), [ze, Ie] = W(null), [ke, _e] = W(null), { dir: Ae } = oo(), U = yo(Pe), u = To({
    middlewares: r,
    width: m,
    position: fo(Ae, n),
    offset: typeof c == "number" ? c + (h ? R / 2 : 0) : c,
    arrowRef: L,
    arrowOffset: b,
    onPositionChange: d,
    positionDependencies: i,
    opened: s,
    defaultOpened: Oe,
    onChange: he,
    onOpen: me,
    onClose: we,
    strategy: j
  });
  Po(() => S && u.onClose(), pe, [
    ze,
    ke
  ]);
  const Me = I(
    (g) => {
      Ie(g), u.floating.refs.setReference(g);
    },
    [u.floating.refs.setReference]
  ), $e = I(
    (g) => {
      _e(g), u.floating.refs.setFloating(g);
    },
    [u.floating.refs.setFloating]
  ), je = I(() => {
    var g;
    (g = a == null ? void 0 : a.onExited) == null || g.call(a), f == null || f();
  }, [a == null ? void 0 : a.onExited, f]), Ke = I(() => {
    var g;
    (g = a == null ? void 0 : a.onEntered) == null || g.call(a), p == null || p();
  }, [a == null ? void 0 : a.onEntered, p]);
  return /* @__PURE__ */ ae(
    Oo,
    {
      value: {
        returnFocus: be,
        disabled: Re,
        controlled: u.controlled,
        reference: Me,
        floating: $e,
        x: u.floating.x,
        y: u.floating.y,
        arrowX: (B = (Y = (X = u.floating) == null ? void 0 : X.middlewareData) == null ? void 0 : Y.arrow) == null ? void 0 : B.x,
        arrowY: (q = (Z = (H = u.floating) == null ? void 0 : H.middlewareData) == null ? void 0 : Z.arrow) == null ? void 0 : q.y,
        opened: u.opened,
        arrowRef: L,
        transitionProps: w(l({}, a), { onExited: je, onEntered: Ke }),
        width: m,
        withArrow: h,
        arrowSize: R,
        arrowOffset: b,
        arrowRadius: C,
        arrowPosition: T,
        placement: u.floating.placement,
        trapFocus: ge,
        withinPortal: E,
        portalProps: F,
        zIndex: ye,
        radius: ve,
        shadow: xe,
        closeOnEscape: N,
        onClose: u.onClose,
        onToggle: u.onToggle,
        getTargetId: () => `${U}-target`,
        getDropdownId: () => `${U}-dropdown`,
        withRoles: De,
        targetProps: Fe,
        __staticSelector: $,
        classNames: x,
        styles: P,
        unstyled: O,
        variant: Ce,
        keepMounted: Te,
        getStyles: K,
        resolvedStyles: Ne,
        floatingStrategy: j
      },
      children: [
        o,
        Ee && /* @__PURE__ */ v(
          de,
          {
            transition: "fade",
            mounted: u.opened,
            duration: (a == null ? void 0 : a.duration) || 250,
            exitDuration: (a == null ? void 0 : a.exitDuration) || 250,
            children: (g) => /* @__PURE__ */ v(ie, { withinPortal: E, children: /* @__PURE__ */ v(
              go,
              l(l({}, y), K("overlay", {
                className: y == null ? void 0 : y.className,
                style: [g, y == null ? void 0 : y.style]
              }))
            ) })
          }
        )
      ]
    }
  );
}
k.Target = ue;
k.Dropdown = M;
k.displayName = "@mantine/core/Popover";
k.extend = (e) => e;
export {
  k as P
};
